<template>
  <div class="city-locate">
    <button
      class="city-locate__button"
      type="button"
      :disabled="isLocating"
      @click="locateCity"
    >
      <svg aria-hidden="true" class="icon">
        <use href="#location-crosshairs" />
      </svg>
      <span v-text="label" />
    </button>

    <transition name="city-locate-error">
      <p
        class="city-locate__error"
        role="alert"
        v-if="errorText"
        v-text="errorText"
      />
    </transition>
  </div>
</template>

<script>
  import {
    LOCATION_ERROR,
    useCurrentLocation,
  } from "Composables/useCurrentLocation";

  const LOCATION_MESSAGE = {
    [LOCATION_ERROR.Denied]: "locationDenied",
    [LOCATION_ERROR.NoMatch]: "locationNoMatch",
  };

  export default {
    computed: {
      errorText() {
        if (!this.locationError) {
          return "";
        }

        return this.texts[
          LOCATION_MESSAGE[this.locationError] ?? "locationFailed"
        ];
      },

      /** Sharing a row with the search field leaves room for the short pair. */
      label() {
        if (this.isLocating) {
          return this.compact ? this.texts.locatingShort : this.texts.locating;
        }

        return this.compact ? this.texts.myLocation : this.texts.useMyLocation;
      },
    },

    data() {
      return {
        texts: theme_vars.cityCaseTypeSelect,
      };
    },

    emits: ["select"],

    methods: {
      async locateCity() {
        const city = await this.locate();

        if (city) {
          this.$emit("select", city);
        }
      },
    },
    name: "CityPanelLocate",

    props: {
      /** Set where the button sits beside the field rather than under it. */
      compact: {
        default: false,
        type: Boolean,
      },
    },

    setup() {
      const { isLocating, error: locationError, locate } = useCurrentLocation();
      return { isLocating, locate, locationError };
    },
  };
</script>
